import React, { Component } from 'react';
import { BrowserRouter, HashRouter, Route, Switch, Redirect } from 'react-router-dom'
import './styles/App.css';
import { Provider } from 'react-redux'
import Navbar from './components/Navbar'
import Home from './components/Home'
import CheckOut from './components/Recipe'
import Cart from './components/Cart'
import Start from './components/Start'
import Confirm from './components/Confirm'

const commonUrl = "https://apps2.housing.k-state.edu/code/bakery/"
class App extends Component {
  render() {
    return (

      <HashRouter basename="/" >

        <div className="App">

          {localStorage.getItem('idOrder') ? (<Redirect to='/Confirm' />) : (<label></label>)}


          <Switch>
            <Route exact path="/"  render={(props) => <Start {...props} commonUrl={commonUrl}  />} />
            <Route exact path="/home" render={(props) => <Home {...props} isAuthed={false} />} />
            <Route path="/cart" render={(props) => <Cart {...props} commonUrl={commonUrl}  />}  />
            <Route path="/confirm" render={(props) => <Confirm {...props} commonUrl={commonUrl}  />}  />
            <Route path="/checkout" render={(props) => <CheckOut {...props} commonUrl={commonUrl}  />} />


          </Switch>

        </div>
      </HashRouter>

    );
  }
}

export default App;
